import flatten from 'lodash/flatten';
import difference from 'lodash/difference';

const excludeContentTypes = ['peerQuestion'];

function getOfferContentIds(offer) {
  const children = offer.children || [];
  const childrenContentIds = flatten(children.map(c => getOfferContentIds(c)));

  const offerType = offer.offerType;
  const offerId = offer._id;
  return excludeContentTypes.includes(offerType)
    ? childrenContentIds
    : [offerId, ...childrenContentIds];
}

function getStateContentIds(states) {
  return states.map(s => s && s.contentId);
}

export default function getNonCreatedStatesForOffer(offer, states) {
  const allOfferContentIds = getOfferContentIds(offer);
  const allStateContentIds = getStateContentIds(states);

  return difference(allOfferContentIds, allStateContentIds);
}
